import styled from 'styled-components'

interface InputContainerProps {
  errors: boolean
}

export const InputContainer = styled.div<InputContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;

  input {
    width: 100%;
    height: 50px;
    border: 1px solid
      ${props => (props.errors ? 'var(--red1)' : 'var(--grey3)')};
    border-radius: 5px;
    padding: 0 20px;
    font-size: 14px;
  }

  @media (max-width: 900px) {
    gap: 8px;
  }
`
